<div
  class="thi-landing-root min-h-screen bg-background text-foreground"
  [attr.dir]="dir"
  [class.font-inter]="fontClass === 'font-inter'"
  [class.font-cairo]="fontClass === 'font-cairo'"
  [class.font-heebo]="fontClass === 'font-heebo'"
>
  <app-thi-landing-header [lang]="lang"></app-thi-landing-header>
  <ng-content></ng-content>
  <app-thi-landing-footer [lang]="lang"></app-thi-landing-footer>
</div>
